import { render, staticRenderFns } from "./VerifiedUsers.vue?vue&type=template&id=68cd65e2"
import script from "./VerifiedUsers.vue?vue&type=script&lang=js"
export * from "./VerifiedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports